exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr td.half-padding[data-v-520c64d0] {\n  padding: 4px;\n}\ntr.selected[data-v-520c64d0] {\n  background-color: #1890ff1c;\n}\ntable th.compact[data-v-520c64d0], table td.compact[data-v-520c64d0] {\n  white-space: nowrap;\n  width: 1px !important;\n}\ntr .pencil-icon[data-v-520c64d0] {\n  display: none;\n}\ntr:hover .pencil-icon[data-v-520c64d0] {\n  display: initial;\n}\n.responsive-height-wrapper[data-v-520c64d0] {\n  max-height: 400px;\n  overflow: auto;\n}\n", ""]);

// exports
